import { useProjectContext } from "../context/useProjectContext";

const useMemberProductAccess = (productSlug) => {
  const { currentMembership, isAdmin, canAccessProduct } = useProjectContext();

  const hasProductAccess = !isAdmin && canAccessProduct(productSlug);

  return { hasProductAccess, isAdmin, currentMembership };
};

export default useMemberProductAccess;
